import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Title from '../../../components/Title';
import { filterStores } from '../../../store/slices/storesSlice';
import { StoreCategory } from '../../../types/store';
import StoreList from '../../../components/StoreList';
const PartnerStores = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(filterStores({ categories: [StoreCategory.Gas, StoreCategory.Cafe, StoreCategory.Bar, StoreCategory.Store] }));
        return () => {
            dispatch(filterStores({}));
        };
    }, []);
    return (_jsx("div", { children: _jsx(StoreList, { headerComponent: _jsx(Title, { viewInMap: true, title: t('store_locator.stores.partner.title') }) }) }));
};
export default PartnerStores;
